import React, { FC, useContext, useEffect } from 'react';
import { CurrentUserContext } from '../contexts/CurrentUserContext';
import { mapAdminRoles } from '../helpers/mapRoles';
import { useHistory } from 'react-router-dom';
import { AuthenticatedRoutes } from '../routers/AuthenticatedRoutes';
import { Nothing } from '../components/Nothing/Nothing';

export const MainPage: FC = () => {
  const { userInfo } = useContext(CurrentUserContext);
  const history = useHistory();

  const isPixotopeAccount = mapAdminRoles(userInfo?.roles ?? []).length > 0;
  const isOrganizationAccount = userInfo?.organizations?.length ?? 0 > 0;

  useEffect(() => {
    if (isPixotopeAccount) {
      history.replace(AuthenticatedRoutes.GlobalOverview());
    } else if (isOrganizationAccount) {
      history.replace(AuthenticatedRoutes.CurrentOrganizationOverview());
    }
  }, [isPixotopeAccount, isOrganizationAccount]);

  /**
   * Wait userInfo is empty and redirect if isPixotopeAccount or if isOrganizationAccount
   */
  if (!userInfo || isPixotopeAccount || isOrganizationAccount) return null;

  return (
    <Nothing
      showContactAdmin={false}
      showLogoutButton={true}
      title={'You\u2019re not part of any organization yet'}
      description={'Contact your organization admin to gain access, or ask to be invited to a different organization.'}
    />
  );
};
